import {
    Component,
    Prop,
    Host,
    Event,
    EventEmitter,
    State,
    h,
} from "@stencil/core";
const baseClass = "ux-file-upload-thumbnail";

@Component({
    tag: "ux-file-upload-thumbnail",
    styleUrl: "file-upload-thumbnail.scss",
    shadow: false,
})
export class FileUploadThumbnail {
    private thumbnailInner: HTMLDivElement | null = null;

    /** the file type of the associated file */
    @Prop() fileType: string = "";
    /** the fileitself to render an image thumbnail */
    @Prop() file: File | null = null;
    /** the file name of the associated file */
    @Prop() fileName: string = "";
    /** the data-file-input-id of the associated file input */
    @Prop() fileInputId: string = "";

    @State() isImageFile = false;
    @State() iconName: string = "";

    private getIconName = () => {
        if (this.fileType === "application/pdf") return "file-pdf";
        else return "file-generic";
    };

    connectedCallback() {
        this.isImageFile = this.fileType.startsWith("image/");
    }

    componentDidLoad() {
        if (!this.isImageFile) {
            this.iconName = this.getIconName();
        } else {
            const img = document.createElement("img");
            //@ts-ignore
            img.file = this.file;
            const reader = new FileReader();
            reader.onload = (function (aImg) {
                return function (e: any) {
                    aImg.src = e.target.result;
                };
            })(img);
            reader.readAsDataURL(this.file);
            this.thumbnailInner.insertAdjacentElement("afterbegin", img);
        }
    }

    // handle deletion of file
    @Event({
        eventName: "uxFileUploadDelete",
        composed: true,
        cancelable: true,
        bubbles: true,
    })
    fileUploadDelete: EventEmitter;

    private onDelete = () => {
        this.fileUploadDelete.emit({ fileInputId: this.fileInputId });
    };

    render() {
        return (
            <Host class={baseClass}>
                <div
                    class={`${baseClass}__inner`}
                    ref={(el) => (this.thumbnailInner = el)}
                >
                    {!this.isImageFile && (
                        <ux-icon name={this.iconName} weight="light"></ux-icon>
                    )}
                    <button
                        class={`${baseClass}__delete-overlay`}
                        onClick={this.onDelete}
                        type="button"
                    >
                        <ux-icon name="bin" weight="normal"></ux-icon>
                    </button>
                </div>
                <span class={`${baseClass}__name`}>{this.fileName}</span>
            </Host>
        );
    }
}
